import { render } from "./GatewayDetails.vue?vue&type=template&id=f6d4c42a&ts=true"
import script from "./GatewayDetails.vue?vue&type=script&lang=ts"
export * from "./GatewayDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__